<template>
    <div class="preview" data-test="alert-preview">
        <div class="preview-label">
            <slot name="label">Preview</slot>
        </div>
        <template v-if="blocks">
            <div class="preview-title">{{ title }}</div>
            <div v-for="(section, index) in sections" :key="index" class="preview-body">{{ section }}</div>
            <div class="preview-footer">{{ footer }}</div>
        </template>
    </div>
</template>

<script>
import { computed } from "vue";

// Renders the Block Kit message the API produced (header, sections, context) as
// plain text - close to what lands in Slack, without rendering any markup. Slack
// shows its three escapes as the characters, so the preview does too (text
// interpolation, never v-html, so this cannot inject markup).
const unescapeSlack = (text) => text.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
const blockText = (block) => unescapeSlack(block?.text?.text || block?.elements?.[0]?.text || "");

export default {
    name: "LaSlackPreview",
    props: {
        blocks: {
            type: Array,
            default: null,
        },
    },
    setup(props) {
        const title = computed(() => blockText(props.blocks?.[0]));
        const sections = computed(() =>
            (props.blocks || []).filter((block) => block.type === "section").map(blockText)
        );
        const footer = computed(() => blockText((props.blocks || []).find((block) => block.type === "context")));
        return { title, sections, footer };
    },
};
</script>

<style lang="scss" scoped>
.preview {
    margin-top: 1rem;
    padding: 0.8rem 1rem;
    border-left: 4px solid $green;
    border-radius: $normal-radius;
    background-color: rgba(128, 128, 128, 0.1);
    &-label {
        font-size: 0.75rem;
        text-transform: uppercase;
        opacity: 0.6;
        margin-bottom: 0.4rem;
    }
    &-title {
        font-weight: 700;
        font-size: 1.05rem;
        margin-bottom: 0.4rem;
    }
    &-body {
        white-space: pre-wrap;
        word-break: break-word;
        font-size: 0.9rem;
        margin-bottom: 0.4rem;
    }
    &-footer {
        font-size: 0.75rem;
        opacity: 0.6;
    }
}
</style>
